<div class="component-container">
  <div class="component-header">
    <h2>Create New Pyramidal Shareholder</h2>
  </div>
  <app-pyramidal-shareholder-form
    [form]="form"
    [isEditMode]="false"
    submitButtonText="Create Pyramidal Shareholder"
    (submit)="onSubmit()"
    (cancel)="onCancel()">
  </app-pyramidal-shareholder-form>
</div>
